import React from "react";

const TestResultDownload = () => {
  return <div></div>;
};

export default TestResultDownload;
